import * as Sentry from '@sentry/react';
import { env } from '@/utils';
import { environments } from '@/constants';

/**
 * Central Sentry configuration for the app.
 *
 * - Initializes Sentry SDK
 * - Adds tracing + session replay
 * - Enriches events with axios + browser context in beforeSend
 */
Sentry.init({
	dsn: 'https://888e5b3ebadacc689d4169815fcbf367@o4510229080965120.ingest.us.sentry.io/4510229519728640',
	environment: environments[import.meta.env.VITE_ENV as keyof typeof environments] || 'QA',

	// Send default PII (e.g. IP address auto-collection)
	sendDefaultPii: true,

	integrations: [
		// Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],

	// Tracing
	tracesSampleRate: 1.0,

	// Enable distributed tracing only for our backends + localhost
	tracePropagationTargets: [
		'localhost',
		import.meta.env.VITE_AUTH_URL,
		import.meta.env.VITE_INVOICE_URL,
		import.meta.env.VITE_BV_URL,
		import.meta.env.VITE_ORDERS_URL,
		import.meta.env.VITE_PATIENT_URL,
		import.meta.env.VITE_COMMON_URL,
		import.meta.env.VITE_NOTIFICATIONS_URL,
		import.meta.env.VITE_USERS_URL,
		import.meta.env.VITE_BGCRON_URL,
		import.meta.env.VITE_CASES_URL,
		import.meta.env.VITE_CRASH_URL,
	].filter(Boolean) as string[],

	// Session Replay
	replaysSessionSampleRate: env === 'prod' ? 0.1 : 1.0,
	replaysOnErrorSampleRate: 1.0,

	// SDK logs (noisy in prod, useful in lower envs)
	enableLogs: env !== 'prod',

	beforeSend(event, hint) {
		try {
			const headers = {
				referer: document.referrer,
				userAgent: navigator.userAgent,
			};
	
			event.extra = {
				...event.extra,
				currentUrl: window.location.href,
				currentPath: window.location.pathname,
				componentStack:
					(hint?.originalException as any)?.stack ||
					(hint?.mechanism as any)?.data?.function ||
					null,
				requestHeaders: headers,
			};
		} catch (err) {
			console.warn('Sentry beforeSend error:', err);
		}
	
		return event;
	},
});

export default Sentry;


